"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultModularNavigationTheme = exports.defaultLocale = void 0;
exports.defaultLocale = 'ru';
exports.defaultModularNavigationTheme = {
    navigationIcon: {
        color: '#ffffff',
    },
    moduleIcon: {
        background: 'linear-gradient(136.36deg, #F4D011 -3.85%, #FFE539 108.38%)',
        color: '#ffffff',
        colorGradient: 'linear-gradient(135deg, #FFFFFF 0%, rgba(255, 255, 255, 0.6) 100%)',
    },
};
